import * as echarts from 'echarts';
import { useCallback, useEffect, useRef } from 'react';
import { setChartOptions } from '../const/chartOptions';
import styles from '../index.less';

const IncomeChart = ({ hideTitle = false, chartData, valName }) => {
  const chartRef = useRef(null);

  const reducerDate = date => {
    return date.replace(/(\d{4})(\d{2})(\d{2})/, (match, $1, $2, $3) => [$2, $3].join('-'));
  };

  const parseChartData = useCallback(data => {
    const xAxisData = [],
      yAxisData = [];
    if (data && data.length > 0)
      data.forEach(item => {
        xAxisData.push(reducerDate(item.d));
        yAxisData.push(item[valName]);
      });
    return { xAxisData, yAxisData };
  }, [valName]);

  useEffect(() => {
    if (!chartData?.length) return;
    if (!chartRef.current) {
      chartRef.current = echarts.init(document.getElementById('incomeChart'));
    }
    const { xAxisData, yAxisData } = parseChartData(chartData);
    const chartOption = setChartOptions({ xAxisData, yAxisData });
    chartRef.current.setOption(chartOption);
  }, [chartData, parseChartData]);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
      }
    };
  }, []);

  return (
    <div>
      <div className={styles.userChartBox}>
        <div className={styles.userCharTit}>
          {!hideTitle && <h3>收益趋势</h3>}
          <p className={styles.incomeCalculation}>计算方式：云豆/100+现金</p>
        </div>
        {chartData?.length > 0 && (
          <div className={styles.userChar}>
            <div className={styles.userCharBox} id="incomeChart"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IncomeChart;
